import { createGtm, type VueGtmUseOptions } from '@gtm-support/vue-gtm'
import { defineNuxtPlugin, useRouter, useRuntimeConfig } from '#app'

interface GTMConfigExtended {
  debug: boolean
  devtools: boolean
  enableRouterSync: boolean
  id: string
  source?: string
}

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    const router = useRouter()
    const config = useRuntimeConfig()
    const options = config.public.gtm as GTMConfigExtended

    if (!options.id && !options.source) {
      console.warn('GTM ID is not configured')
      return
    }

    console.log('Initialising GTM...', options.id)

    const pluginOptions: VueGtmUseOptions = {
      ...options,
      vueRouter:
        options.enableRouterSync && router
          ? (router as VueGtmUseOptions['vueRouter'])
          : undefined,
      id: options.id,
    }

    nuxtApp.vueApp.use(createGtm(pluginOptions))
  }
})
